import { ColorEnum } from 'shared/design-system/data-access/theme';
import { BorderConfig } from './border-config.model';

export const borderConfig: BorderConfig = {
    color: ColorEnum.PRIMARY_COLOR,
    size: '2px',
    style: 'dashed',
};
